import type {StarterEntry, StarterGroup} from '@github-ui/copilot-chat/utils/copilot-chat-types'
import {VerifiedHTMLDiv} from '@github-ui/safe-html/VerifiedHTML'
import {ActionList, ActionMenu} from '@primer/react'
import {useRef, useState} from 'react'

import {StarterPill} from './StarterPill'

export function StarterGroupWithMenu({
  group,
  onEntrySelect,
}: {
  group: StarterGroup
  onEntrySelect: (entry: StarterEntry) => void
}) {
  const [open, setOpen] = useState(false)
  const buttonRef = useRef<HTMLButtonElement>(null)

  const handleClick = () => {
    setOpen(!open)
  }

  // If there's only one entry, render a simple StarterPill without dropdown
  if (group.entries.length === 1) {
    const singleEntry = group.entries[0]!
    return (
      <li>
        <StarterPill
          ref={buttonRef}
          testId={group.id}
          name={group.name}
          icon={group.icon}
          color={group.color}
          onClick={() => onEntrySelect(singleEntry)}
          dropdown={false}
        />
      </li>
    )
  }

  return (
    <li>
      <ActionMenu open={open} onOpenChange={setOpen}>
        <ActionMenu.Anchor>
          <StarterPill
            ref={buttonRef}
            testId={group.id}
            name={group.name}
            icon={group.icon}
            color={group.color}
            onClick={handleClick}
            dropdown
            open={open}
          />
        </ActionMenu.Anchor>
        <ActionMenu.Overlay style={{width: '260px'}}>
          <ActionList>
            {group.entries.map(entry => (
              <ActionList.Item key={entry.id} onSelect={() => onEntrySelect(entry)}>
                <VerifiedHTMLDiv html={entry.titleHtml} />
              </ActionList.Item>
            ))}
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
    </li>
  )
}
